// import {selectIsNorthAmerica} from '@/store/slices/countryCodeSlice'
// import {useSelector} from 'react-redux'
import {ProductReviewPage as NorthAmericaProductReview} from '@/features/ProductReview/ProductReviewPage'
import {selectIsNorthAmerica} from '@/store/slices/countryCodeSlice'
import {useSelector} from 'react-redux'
import ProductReview from './ProductReview'

const ProductReviewByMarket = () => {
  const isNorthAmerica = useSelector(selectIsNorthAmerica)

  if (isNorthAmerica) {
    return <NorthAmericaProductReview />
  }

  return <ProductReview />
}

export default ProductReviewByMarket
